import React from "react";
import { Navigate, useRoutes } from "react-router-dom";
import ManageLayout from "../layout/manage";
import ReportManage from "../pages/manage/report";
import RequestManage from "../pages/manage/request";
import ProfileManage from "../pages/manage/profile";
import ProfileDetail from "../pages/manage/profile/detail";
import ProfileAppearance from "../layout/profile/appearance";
import AppearanceWindow from "../pages/manage/profile/detail/appearance/window";
import AppearanceChatBadge from "../pages/manage/profile/detail/appearance/chat-badge";
import AppearanceContent from "../pages/manage/profile/detail/appearance/content";
import Routing from "../pages/manage/profile/detail/routing";
import ProfileInfo from "../layout/profile/info";
import ProfileInitInfo from "../pages/manage/profile/detail/info";
import ProfileBusinessHours from "../pages/manage/profile/detail/info/business-hours";
import ProfileForm from "../layout/profile/form";
import FormConfig from "../pages/manage/profile/detail/form/configuration";
import ProfileShorthand from "../pages/manage/profile/detail/shorthand";
import ProfileTrigger from "../pages/manage/profile/detail/trigger";
import AddProfile from "../pages/manage/profile/add";
import AddTrigger from "../pages/manage/profile/detail/trigger/add";
import ChatLayout from "../layout/chat";
import ChatPage from "../pages/chat";
import VisitorPage from "../pages/visitor";
import FormField from "../pages/manage/profile/detail/form/field";
import WidgetPage from "../pages/widget";

const Router = () => {
  const elements = useRoutes([
    {
      path: "/widget",
      element: <WidgetPage />,
    },
    {
      path: "/izi-message",
      element: <ManageLayout />,
      children: [
        {
          path: "",
          element: <Navigate to="request" replace />,
        },
        {
          path: "request",
          element: <RequestManage />,
        },
        {
          path: "report",
          element: <ReportManage />,
        },
        {
          path: "profile",
          element: <ProfileManage />,
        },
      ],
    },
    {
      path: "/chat/:id",
      element: <ChatLayout />,
      children: [
        {
          path: "message/session-id/:sessionId",
          element: <ChatPage />,
        },
        {
          path: "visitor",
          element: <VisitorPage />,
        },
      ],
    },
    {
      path: "/profile/:id/detail",
      element: <ProfileDetail />,
    },
    {
      path: "/profile/add",
      element: <AddProfile />,
    },
    {
      path: "/profile/:id/shorthand",
      element: <ProfileShorthand />,
    },
    {
      path: "/profile/:id/trigger",
      element: <ProfileTrigger />,
    },
    {
      path: "/profile/:id/trigger/add",
      element: <AddTrigger />,
    },
    {
      path: "/profile/:id/trigger/edit/trigger-id/:triggerId",
      element: <AddTrigger />,
    },
    {
      path: "/profile/:id/routing",
      element: <Routing />,
    },
    {
      path: "/profile/:id/appearances",
      element: <ProfileAppearance />,
      children: [
        {
          path: "",
          element: <Navigate to="window" replace />,
        },
        {
          path: "window",
          element: <AppearanceWindow />,
        },
        {
          path: "chat-badge",
          element: <AppearanceChatBadge />,
        },
        {
          path: "content",
          element: <AppearanceContent />,
        },
      ],
    },
    {
      path: "/profile/:id/info",
      element: <ProfileInfo />,
      children: [
        {
          path: "",
          element: <ProfileInitInfo />,
        },
        {
          path: "business-hours",
          element: <ProfileBusinessHours />,
        },
      ],
    },
    {
      path: "/profile/:id/form",
      element: <ProfileForm />,
      children: [
        {
          path: "",
          element: <Navigate to="config" replace />,
        },
        {
          path: "config",
          element: <FormConfig />,
        },
        {
          path: "field",
          element: <FormField />,
        },
      ],
    },
  ]);
  return elements;
};

export default Router;
